export enum FontWeight {
  WEIGHT_100 = 'thin',
  WEIGHT_200 = 'extralight',
  WEIGHT_300 = 'light',
  WEIGHT_400 = 'normal', // default value, does not have to be explicitly defined.
  WEIGHT_500 = 'medium',
  WEIGHT_600 = 'semibold',
  WEIGHT_700 = 'bold',
  WEIGHT_800 = 'extrabold',
  WEIGHT_900 = 'black',
}
